import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const CustomModal = ({ show, setShow, title, children, onShow, size = "lg" }) => {
  return (
    <>
      <style>{`
        .custom-modal-content {
          border-radius: 14px !important;
          overflow: hidden !important;
          border: none !important;
          box-shadow: 0 8px 40px rgba(0,0,0,0.18) !important;
        }
      `}</style>
      <Modal
        size={size}
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        contentClassName="custom-modal-content"
        onShow={onShow}
      >
        {/* Header */}
        <div style={{
          background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
          padding: "18px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}>
          <span style={{ fontWeight: 700, fontSize: "1rem", color: "#fff" }}>{title}</span>
          <button onClick={() => setShow(false)} style={{
            background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "8px",
            width: "30px", height: "30px", display: "flex", alignItems: "center",
            justifyContent: "center", cursor: "pointer", color: "#fff", fontSize: "1rem",
          }}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        {/* Body */}
        <div style={{ background: "#f8f9fb" }}>
          {children}
        </div>

        {/* Footer */}
        <div style={{
          background: "#fff", borderTop: "1px solid #f0f0f0",
          padding: "14px 24px", display: "flex", justifyContent: "flex-end",
        }}>
          <button onClick={() => setShow(false)} style={{
            padding: "8px 18px", background: "#f5f5f5", color: "#424242",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
          }}>
            Close
          </button>
        </div>
      </Modal>
    </>
  );
};

export default CustomModal;
